import { BlankState } from '@domain-group/suit-theme'

import BlankStateImage from './assets/no-invoices.svg'

const InvoicesImportBlankState = () => (
  <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImage}>
    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Title>No Invoices Available</BlankState.Title>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>
      No invoices available. If you&apos;re using filters try adjusting them to show more results.
      You can create invoices from order items in campaigns
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Paragraph>
  </BlankState>
)

export default InvoicesImportBlankState
